import { Component, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-form-date',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="form-section">
      <label for="{{ id }}" [class.required-field]="required">{{ label }}</label>
      <div *ngIf="readonly" class="readonly-value">
        {{ formatDateForDisplay(value) }}
      </div>
      <input
        *ngIf="!readonly"
        type="date"
        [id]="id"
        [(ngModel)]="value"
        (ngModelChange)="onChange($event)"
        [name]="name"
        [placeholder]="placeholder"
      />
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormDateComponent),
      multi: true
    }
  ],
  styleUrls: ['total-component.scss']
})
export class FormDateComponent implements ControlValueAccessor {
  @Input() label: string = '';  // 標籤
  @Input() id: string = '';     // id 用於對應 label
  @Input() name: string = '';   // name 用於表單提交
  @Input() placeholder: string = ''; // 佔位符
  @Input() required: boolean = false; // 是否必填
  @Input() readonly: boolean = false; // 新增：只讀模式

  value: string = '';  // 綁定的值

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  // 用於 ControlValueAccessor 實作
  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // 如有需要，可以處理 disabled 狀態
  }

  // 新增：格式化日期顯示
  formatDateForDisplay(dateValue: string): string {
    if (!dateValue) return '-';
    try {
      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return dateValue;
      return date.toLocaleDateString('zh-TW', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch {
      return dateValue;
    }
  }
}
